<template>
  <div>
    <div>
      <v-img src="../assets/banner.jpg" height="550px"></v-img>
    </div>
    <div>
      <news
        :datas="{ news, notice}"
        :show-pagination="true"
        @page="handlePage"
      ></news>
    </div>
  </div>
</template>

<script>
import News from '../components/News.vue';
import { getNewsList, getNotices } from '../api/News';

export default {
  components: { News },
  data() {
    return {
      params: {
        limit: 14,
        page: 1,
      },
      news: {
        data: [],
        extra: {
          total: 0,
          page: 1,
        },
      },
      notice: {
        data: [],
        extra: {
          total: 0,
          page: 1,
        },
      },

      count: 0,
    };
  },

  async beforeMount() {
    this.fetchNews();
    this.fetchNotice();
  },

  methods: {
    handlePage(payload) {
      if (payload.type === 'news') {
        this.fetchNews(payload.value);
      } else {
        this.fetchNotice(payload.value);
      }
    },
    /**
     * 分页信息
     * @param { Number} page 需要请求的页面
     */
    async fetchNews(page = 1) {
      this.params.page = page;
      const { data: { data } } = await getNewsList({ ...this.params, page });
      this.news = {
        ...data,
        extra: {
          ...data.extra,
          page: parseInt(data.extra.page, 10),
        },
      };
    },

    /**
     * 分页信息
     * @param { Number} page 需要请求的页面
     */
    async fetchNotice(page = 1) {
      const { data: { data } } = await getNotices({ ...this.params, page });
      this.notice = {
        ...data,
        extra: {
          ...data.extra,
          page: parseInt(data.extra.page, 10),
        },
      };
    },
  },
};
</script>

<style scoped>

</style>
